import { render, staticRenderFns } from "./switch-field.vue?vue&type=template&id=ee7ab022&scoped=true&lang=pug"
import script from "./switch-field.vue?vue&type=script&lang=js"
export * from "./switch-field.vue?vue&type=script&lang=js"
import style0 from "./switch-field.vue?vue&type=style&index=0&id=ee7ab022&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7ab022",
  null
  
)

export default component.exports